import * as React from 'react';
import {View} from 'react-native';
import {noop} from 'lodash';

import Icon from '/component/base/Icon';
import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {withCompetency, withTheme} from '/provider/ThemeProvider';
import {useTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
import {withHOC} from '/util/hoc.util';

import {styles} from './Loading.style';
interface LoadingProps {
  getTheme: (key: string) => string;
}

const Loading: React.FC<LoadingProps> = ({getTheme = noop}) => {
  const {tt} = useTranslation('reportCardContent.qualifiedForIncentiveTrip');
  const iconStyle = {
    ...styles.icon,
    color: getTheme('competency.textColor.color'),
  };
  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <View style={styles.headerContainer}>
            <Icon name="circle-checkmark-filled" style={iconStyle} />
            {tt(
              'description',
              generateComponentCallback({
                component: (
                  <Text
                    style={styles.headerText}
                    variant="small"
                    emphasis="low">
                    Qualified for the
                    <Text
                      style={styles.optaText}
                      variant="heading"
                      emphasis="low">
                      {' OPTA'}
                    </Text>
                    VIA Incentive Trip 2024.
                  </Text>
                ),
              }),
            )}
          </View>
        </Gutter>
      </View>
      <Gutter>
        <View style={styles.bonusProgressBar}>
          <View style={styles.bonusProgressBarSection}>
            <LoadingBox style={styles.loadingBoxDate} />
            <LoadingBox style={styles.loadingBoxProgressBarMoneyEarned} />
          </View>
          <LoadingBox style={styles.loadingBoxProgressBar} />
        </View>
      </Gutter>
      <Gutter />
    </View>
  );
};

export default withHOC(withTheme, withCompetency)(Loading);
